import { urlSafeBase64Encode } from './clipboard';

export type TextWatermarkMode = 'southeast' | 'tile';

export interface TextWatermarkConfig {
  text: string;
  fontSize: number;
  opacity: number;
  mode: TextWatermarkMode;
}

export const TEXT_WATERMARK_MAX_LENGTH = 10;

const appendCosQuery = (url: string, query: string): string => {
  return `${url}${url.includes('?') ? '&' : '?'}${query}`;
};

const clampNumber = (value: number, min: number, max: number): number => {
  if (Number.isNaN(value)) {
    return min;
  }
  return Math.min(Math.max(value, min), max);
};

export const buildTextWatermarkUrl = (url: string, config: TextWatermarkConfig): string => {
  const text = urlSafeBase64Encode(config.text.trim());
  const fontSize = clampNumber(config.fontSize, 12, 72);
  const opacity = clampNumber(config.opacity, 1, 100);

  const baseQuery = `watermark/2/text/${text}/fontsize/${fontSize}/fill/IzAwMDAwMA/fontcolor/ffffff/t/${opacity}`;

  if (config.mode === 'tile') {
    return appendCosQuery(url, `${baseQuery}/dissolve/10/gravity/center/batch/1/degree/30`);
  }

  return appendCosQuery(url, `${baseQuery}/gravity/southeast`);
};
